// ------------------------------------------------------------------------------
// name: index
// author: mudas
// created: 2025/3/31
// ------------------------------------------------------------------------------

export type TiangongThemeType = 'dark' | 'light';
export const DEFAULT_THEME = 'dark';
